import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'reactstrap';
import {
  FormattedMessage,
  defineMessages,
  injectIntl,
  intlShape,
} from 'react-intl';

import BarcodeSearchIcon from '../BarcodeSearchIcon';

const messages = defineMessages({
  retryBarcodeSearch: {
    id: 'barcodeSearch.retryBarcodeSearch',
    defaultMessage: 'Retry barcode search',
  },
  retry: {
    id: 'barcodeSearch.retry',
    defaultMessage: 'Retry',
  },
});

/**
 * Contains barcode-search chunk failures so they do not reach the app-wide
 * production error boundary. Lives outside the loadable so it stays mounted.
 */
class BarcodeSearchChunkErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    if (this.props.onRetry) {
      this.props.onRetry();
    }
  };

  render() {
    const { intl } = this.props;

    if (this.state.hasError) {
      return (
        <Button
          className="BarcodeSearchButton BarcodeSearchButton--load-error"
          color=""
          onClick={this.handleRetry}
          type="button"
          aria-label={intl.formatMessage(messages.retryBarcodeSearch)}
        >
          <BarcodeSearchIcon />
          <span className="sr-only">
            <FormattedMessage {...messages.retry} />
          </span>
        </Button>
      );
    }

    return this.props.children;
  }
}

BarcodeSearchChunkErrorBoundary.propTypes = {
  children: PropTypes.node,
  intl: intlShape.isRequired,
  onRetry: PropTypes.func,
};

export default injectIntl(BarcodeSearchChunkErrorBoundary);
